import React, { Component } from 'react';
import { withRouter} from 'react-router-dom';
import { connect } from 'react-redux';

class GateFeeBoarding_dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        try {
            let overDom = document.getElementsByName("newBoardingThankView");
            if(overDom){
              let height1 = document.getElementById('promo-banner-container-second').offsetHeight
              overDom[0].style.top = (height1+47)+'px';
              let stepsDom = document.getElementsByClassName("quiz-steps-container");
              stepsDom[0].style.top = (height1)+'px';
            }
        } catch (error) {
        }
    }

    render() {
        return (
            <div className="skin-dashboard-container navy">
                <div className="skin-dashboard-container-title paragraphSemiBold0">Get excited for your consultation. We can’t wait to meet you!</div>
                <div className="view-skinProfile-zone">
                    <div className="view-skinProfile-title">Your skin profile is ready!</div>
                    <button className="p-a-n-button view-skinProfile-buttom" onClick={()=>{  this.props.history.push('/survey-result'); }}>View skin profile</button>
                </div>

                <div className="paragraphSemiBold0 exploreAvaAcademy-title">Explore Ava Academy</div>
                <div className="paragraphRegular5 exploreAvaAcademy-text">Your go-to place for skincare tips and tricks</div>

                <div className="academy-show-area">
                    <div className="academy-show-area-item">
                        <a href="/BlogDetail/92681994/556283986108">
                            <span className="paragraphSemiBold3">Your exfoliating questions answered</span>
                            <img src="/images/onboardingAA/gateFeeBoarding/academy1.png"></img>
                        </a>
                    </div>
                    <div className="academy-show-area-item">
                        <a href="/BlogDetail/92681994/556273598652">
                            <span className="paragraphSemiBold3">PSA: Protect your skin this summer</span>
                            <img src="/images/onboardingAA/gateFeeBoarding/academy2.png"></img>
                        </a>
                    </div>
                    <div className="academy-show-area-item">
                        <a href="/BlogDetail/92681994/556276121788">
                            <span className="paragraphSemiBold3">The complete guide for using antioxidants in your routine</span>
                            <img src="/images/onboardingAA/gateFeeBoarding/academy3.png"></img>
                        </a>
                    </div>
                </div>
                <button className="new-button-style" onClick={()=>{  this.props.history.push("/Blog") }} style={{margin:'auto', marginTop:'31px',display:'block'}}>Read more</button>
                <div className="skincare-text-style">Stay in touch for daily skincare tips</div>
                <div className="social-icon-group">
                    <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/HelloAVAbeauty/"> <i className="fa fa-facebook fa-fw"></i>  </a>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/helloavabeauty/"> <i className="fa fa-instagram fa-fw"></i> </a>
                </div>
            </div>        
        )
    }
}

export default withRouter(connect()(GateFeeBoarding_dashboard))



// WEBPACK FOOTER //
// ./src/views/onboardingAA/GateFeeBoarding_dashboard.js